import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import SecondaryCta from 'bento-ordering/base/components/SecondaryCta';
import FulfillmentInformation from 'bento-ordering/cart/ui_components/FulfillmentInformation';

class CartPickup extends React.Component {
  static propTypes = {
    handleClick: PropTypes.func,
    fulfillmentTimeOrASAP: PropTypes.string,
    fulfillmentAddress: PropTypes.string
  };

  render() {
    const {
      handleClick,
      fulfillmentTimeOrASAP,
      fulfillmentAddress
    } = this.props;

    return (
      <Box data-testid="fulfillment-information" width="100%" mb={2}>
        <Box mb={1.5}>
          <Box mr={2.5} display="inline">
            <FulfillmentInformation
              title="Pickup Time"
              info={fulfillmentTimeOrASAP}
              onClick={handleClick}
              dataTestId={'pickup-time'}
            />
          </Box>
          <FulfillmentInformation
            title="Pickup From"
            info={fulfillmentAddress}
            onClick={handleClick}
            dataTestId={'pickup-from'}
          />
        </Box>
        <Box position="relative">
          <SecondaryCta
            handleClick={handleClick}
            dataTestId="cart-pickup"
            label="Change"
          />
        </Box>
      </Box>
    );
  }
}

export default CartPickup;
